import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, createContext, useState } from 'react';
export const LosseLayoutContext = createContext({});
export const LosseLayoutProvider = LosseLayoutContext.Provider;
export const LosseLayoutConsumer = LosseLayoutContext.Consumer;
export default function LosseLayout({ children }) {
    const [isSticky, setSticky] = useState(false);
    const [isScrollable, setScrollable] = useState(true);
    const handleScroll = () => {
        setSticky(window.scrollY > 0);
    };
    useEffect(() => {
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', () => handleScroll);
        };
    }, []);
    return _jsx(LosseLayoutProvider, { value: { isScrollable, setScrollable, isSticky, setSticky }, children: children });
}
